import { useState } from "react";
import "./ExaminationSection.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";

const ExaminationSection = () => {
  const [activeTab, setActiveTab] = useState("about");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case "about":
        return (
          <div className="exam-content">
            <h2>About Examination Section</h2>
            <p>
              The Examination Section of Rayalaseema University is responsible
              for planning, conducting, evaluating and publishing results for
              all University examinations. It ensures transparency, integrity,
              confidentiality and strict compliance with academic regulations.
            </p>
            <p>
              The section also provides services like revaluation, recounting,
              transcripts, migration certificates and verification of
              credentials using technology-driven systems.
            </p>

            <a
              href="https://ruk.ac.in/results/"
              target="_blank"
              rel="noopener noreferrer"
              className="result-btn"
            >
              View Results Portal
            </a>
          </div>
        );

      case "dean":
        return (
          <div className="exam-content">
            <h2>Dean of Examinations</h2>
            <div className="profile-card">
              <img src="/telugu/Narasimhulu.JPG" alt="Dean" />
              <div>
                <h4>Dr. N. Narasimhulu</h4>
                <p>Dean of Examinations</p>
                <p>Email: drnnarasimhuluknl@gmail.com</p>
                <p>Phone: 9182034667</p>
              </div>
            </div>
          </div>
        );

      case "controller":
        return (
          <div className="exam-content">
            <h2>Controller of Examinations</h2>
            <div className="profile-card">
              <img src="/person/ce.JPG" alt="Controller" />
              <div>
                <h4>Dr. S. Venkateswarlu</h4>
                <p>Controller of Examinations</p>
                <p>Email: ce@ruk.ac.in</p>
                <p>Phone: 9160001455</p>
              </div>
            </div>
          </div>
        );

      case "ar":
        return (
          <div className="exam-content">
            <h2>Assistant Registrar (Exams)</h2>
            <div className="profile-card">
              <img src="/person/ar.JPG" alt="AR" />
              <div>
                <h4>Smt. N. Thulasamma</h4>
                <p>Assistant Registrar</p>
                <p>Email: thulasamma.nag@gmail.com</p>
                <p>Phone: 9160110219</p>
              </div>
            </div>
          </div>
        );

      case "coordinators":
        return (
          <div className="exam-content">
            <h2>Examination Coordinators</h2>
            <div className="coordinator-grid">


              <div className="profile-card">
                <div>
                  <h4>Dr. Pagadala Suchitra</h4>
                  <p>Email: svijay1820@gmail.com</p>
                  <p>Phone: 9848747421</p>
                </div>
              </div>
              <div className="profile-card">
                <div>
                  <h4>Dr. K. Venkata Ratnam</h4>
                  <p>Email: drvenkatapkd@gmail.com</p>
                  <p>Phone: 8008497926</p>
                </div>
              </div>
              <div className="profile-card">
                <div>
                  <h4>Dr. R. Sreedhar</h4>
                  <p>Email: rayasamsreedhar@gmail.com</p>
                  <p>Phone: 9492405600</p>
                </div>
              </div>
            </div>
          </div>
        );

      case "staff":
        return (
          <div className="exam-content">
            <h2>Examination Section – Staff Details</h2>

            <div className="table-responsive">
              <table className="exam-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name of the Employee</th>
                    <th>Designation</th>
                    <th>Section</th>
                    <th>Mobile Number</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Dr. S. Venkateswarlu</td>
                    <td>Controller of Examinations</td>
                    <td>Examinations Section</td>
                    <td>9491945995</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>N. Thulasamma</td>
                    <td>Assistant Registrar</td>
                    <td>Examinations Section</td>
                    <td>9160110219</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>N. Vijayalakshmi</td>
                    <td>Junior Assistant</td>
                    <td>Examinations Section</td>
                    <td>9704233136</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>B. Girijamma</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9441690147</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>K. Veera Swamy</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>8121839170</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>S. Amzad Basha</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>8142392886</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>D. Sekhar</td>
                    <td>Office Assistant</td>
                    <td>Examinations Section</td>
                    <td>9963956004</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>B. Chinna Hussainaiah</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9959493432</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>G. Thirupathaiah</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9492406243</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Sk Nazimunnesha Begam @ P. Roja</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9550078581</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>K.V. Chalapathi</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9441409530</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>M. Rajesh</td>
                    <td>Office Assistant</td>
                    <td>Examination Section</td>
                    <td>9581187372</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>M. Jyothi</td>
                    <td>Office Assistant</td>
                    <td>Examinations Section</td>
                    <td>9347725262</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );


      default:
        return null;
    }
  };

  return (
    <>
      <Navbar />

      {/* Banner */}
      <div className="exam-banner">
        <img src="/person/exambanner.JPG" alt="Exams" />
        <div className="exam-banner-overlay">
          <h1>Examination Section</h1>
          <p>Rayalaseema University</p>
        </div>
      </div>

      {/* Layout */}
      <div className="exam-content-wrapper">

        {/* Mobile Toggle */}
        <button
          className="exam-mobile-sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? "✕ Close Menu" : "☰ Examination Navigation"}
        </button>

        {/* Sidebar */}
        <aside className={`exam-sidebar ${isSidebarOpen ? "exam-sidebar-open" : ""}`}>
          <div className="exam-sidebar-header">
            <h3>Examination</h3>
          </div>

          <nav className="exam-sidebar-nav">
            {["about", "dean", "controller", "ar", "coordinators", "staff"].map(tab => (
              <button
                key={tab}
                className={`exam-nav-item ${activeTab === tab ? "exam-nav-item-active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setIsSidebarOpen(false);
                }}
              >
                {tab === "ar" ? "Assistant Registrar" : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </nav>
        </aside>

        {/* Main */}
        <main className="exam-main">
          {renderContent()}
        </main>
      </div>

      <Footer />
    </>
  );
};

export default ExaminationSection;
